// Signs the user out after a period of inactivity (org_settings.session_idle_minutes).
// Activity in any tab of the app resets the timer (shared via localStorage timestamp).

const ACTIVITY_KEY = 'ngw.lastActivity';
const EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'];

export function startIdleTimeout({ minutes, onWarn, onTimeout, warnSeconds = 60 }) {
  const limitMs = Math.max(5, Number(minutes) || 30) * 60_000;
  let warned = false;
  let lastWrite = 0;

  const touch = () => {
    const now = Date.now();
    if (now - lastWrite < 5000) return; // throttle writes
    lastWrite = now;
    warned = false;
    try { localStorage.setItem(ACTIVITY_KEY, String(now)); } catch { /* ignore */ }
  };
  const last = () => {
    try { return Number(localStorage.getItem(ACTIVITY_KEY)) || lastWrite || Date.now(); } catch { return lastWrite || Date.now(); }
  };

  touch();
  EVENTS.forEach((e) => window.addEventListener(e, touch, { passive: true }));

  const timer = setInterval(() => {
    const idle = Date.now() - last();
    if (idle >= limitMs) {
      stop();
      onTimeout?.();
    } else if (!warned && idle >= limitMs - warnSeconds * 1000) {
      warned = true;
      onWarn?.(Math.round((limitMs - idle) / 1000));
    }
  }, 5000);

  function stop() {
    clearInterval(timer);
    EVENTS.forEach((e) => window.removeEventListener(e, touch));
  }
  return stop;
}
